export default "__VITE_ASSET__3QN4JP0V__"